import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { store } from "@/state/store";
import ValidationText from "@SharedVueComponents/SharedForm/ValidationText.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalError',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(store).globalErrorMessages.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).globalErrorMessages, (error, i) => {
          return (_openBlock(), _createBlock(ValidationText, {
            key: error + i,
            "error-message": error,
            "no-indent": ""
          }, null, 8, ["error-message"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})